import * as $ from "jquery";

const TITLETEXT =
    "<div class='title'><h2 class='title-text'></h2><h2><strong class='close pointer'>&times;</strong></h2></div>";

// This handles our standard mobile popup
export class ModalPopup {
    $modal: JQuery; //container
    $info: JQuery;

    constructor($modal: JQuery, $info: JQuery, title?: string) {
        const self = this;
        this.$modal = $modal;
        this.$info = $info;
        this.$info.prepend(TITLETEXT);

        if (title) {
            this.setTitle(title);
        }

        //clicking on the close button hides
        this.$modal.find(".title .close").on("click", function () {
            self.hide();
        });
        // clicking on the mask hides
        this.$modal.find(".mask").on("click", function () {
            self.hide();
        });
    }

    setTitle(title: string) {
        this.$modal.find(".title-text").text(title);
    }

    show() {
        this.$modal.css("display", "flex");
    }

    hide() {
        this.$modal.fadeOut(100);
    }
}
